<template>
  <v-dialog :persistent="confirmModel.alert" v-model="model" max-width="400px">
    <v-sheet class="ma-0 pa-0 pa-4">
      <v-row class="ma-0 pa-0">
        <p class="mb-3 pa-0 ma-0" v-html="confirmModel.text"></p>
      </v-row>
      <v-row class="ma-0 mt-5 pa-0">
        <v-btn
          class="text-none confirm-button mb-2"
          color="primary"
          elevation="0"
          block
          @click="confirmAction()"
          >{{ confirmModel.confirmText }}</v-btn
        >
        <v-btn
          v-if="!confirmModel.alert"
          class="text-none confirm-button"
          elevation="0"
          block
          outlined
          color="primary"
          @click="cancel()"
          >{{ confirmModel.closeText }}</v-btn
        >
      </v-row>
    </v-sheet>
  </v-dialog>
</template>

<style>
.confirm-button {
  font-size: 16px !important;
  font-weight: normal;
}
.confirm-max-width {
  max-width: 300px;
}
</style>

<script>
import {} from "@mdi/js";
import { mapGetters, mapMutations } from "vuex";
import labels from "@/constants/labels.js";
export default {
  name: "Confirm",
  computed: {},
  props: {},
  methods: {
    ...mapMutations("general", ["closeConfirmModel"]),
    closeModal() {
      this.model = false;
    },
    cancel() {
      this.model = false;
      if (this.confirmModel.cancelAction) {
        this.$store.dispatch(
          this.confirmModel.cancelAction,
          this.confirmModel.cancelParameters,
          { root: true }
        );
      }
    },
    confirmAction() {
      this.model = false;
      if (!this.confirmModel.callback && !!this.confirmModel.action) {
        this.$store.dispatch(
          this.confirmModel.action,
          this.confirmModel.parameters,
          {
            root: true,
          }
        );
      } else if (!!this.confirmModel.callback) {
        this.confirmModel.callback();
      }
    },
  },
  computed: {
    ...mapGetters("general", ["confirmModel"]),
    model: {
      get() {
        return this.confirmModel.active;
      },
      set(val) {
        this.closeConfirmModel();
      },
    },
  },
  data() {
    return {
      close: labels.CLOSE,
    };
  },
};
</script>